import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from '@material-ui/core'
import { sendValidationEmail } from '../../../actions/emailActions'
import FormContainer from '../../Form/FormContainer'
import { USER_REGISTER_RESET } from '../../../constants/userConstants'
import ToastMessage from '../../ToastMessage/ToastMessage'

const SignUpSuccess = () => {
  const dispatch = useDispatch()

  const [validationSent, setValidationSent] = useState(false)
  const [toast, setToast] = useState(false)

  const userRegister = useSelector((state) => state.userRegister)
  const { registration } = userRegister

  useEffect(() => {
    if (!validationSent && registration) {
      dispatch(sendValidationEmail(registration))
      setValidationSent(true)
    }
  }, [registration, validationSent, dispatch])

  useEffect(() => {
    const resetUserRegister = () => {
      dispatch({ type: USER_REGISTER_RESET })
    }
    return () => {
      resetUserRegister()
    }
  }, [dispatch])

  const handleSendValidationEmail = () => {
    dispatch(sendValidationEmail(registration))
    setToast(true)
  }

  return (
    <>
      <div className="login flex">
        <div
          className="bg-image"
          style={{ backgroundImage: "url('/images/login-bg.jpg')" }}
        ></div>
        <FormContainer>
          <h1>Thank you for joining MyQuality!</h1>
          <p className="m-t-20 fs14">
            Click the link in your inbox to verify your email address and finish
            sign up. Don’t see an email from us? Check your spam folders or
            resend.
          </p>

          <div className="flex flex-end m-t-40">
            <Button
              onClick={handleSendValidationEmail}
              variant="contained"
              color="primary"
            >
              Resend verfication
            </Button>
          </div>
        </FormContainer>
      </div>
      <ToastMessage
        message={
          <>
            <p className="fs16 fw600">Validation email sent</p>
            <p className="fs14 m-b-0">
              If you cannot locate the email, please check your spam folder.
            </p>
          </>
        }
        open={toast}
        setOpen={setToast}
      />
    </>
  )
}

export default SignUpSuccess
